var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanderConceptIconBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6619 0.645996H3.35073C1.89874 0.645996 0.72168 1.82306 0.72168 3.27504V15.2784C0.72168 16.7303 1.89874 17.9074 3.35073 17.9074H24.6619C26.1139 17.9074 27.291 16.7303 27.291 15.2784V3.27504C27.291 1.82306 26.1139 0.645996 24.6619 0.645996Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6467 3.30151H5.36865C4.26867 3.30151 3.37695 4.19323 3.37695 5.29321C3.37695 6.3932 4.26867 7.28492 5.36865 7.28492H18.6467C19.7466 7.28492 20.6384 6.3932 20.6384 5.29321C20.6384 4.19323 19.7466 3.30151 18.6467 3.30151Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanderConceptIconBattery);
export default __webpack_public_path__ + "static/media/lander-concept-icon-battery.ad13431c73488b28da8f8dfcaf4c8a74.svg";
export { ForwardRef as ReactComponent };